import React from "react";
import PropTypes from "prop-types";

const HeaderSection = props => {
	const { title, icon, goBack, actions } = props;

	const { lang } = global;

	return (
		<>
			<div className="row">
				<div className="col-md-6">
					<button
						type="button"
						className="btn btn-link padding-left-0 btn-margin-top-4"
						onClick={goBack}
						data-test-id="go-back-btn"
					>
						<i className="rkf rkf-chevron-left" />
						{` ${lang.t("Go Back")}`}
					</button>
				</div>
			</div>
			<div className="row">
				<div className="col-md-12 header-container padding-bottom-16 padding-top-8 flex flex-justify-content-center flex-align-items-center hidden-lg hidden-xl">
					<div className="header-title flex flex-align-items-center flex-justify-content-center flex-gap-8">
						<img
							src={icon}
							alt={title}
							height={40}
							width={40}
						/>
						<h3 className="title font-black">{lang.t(title)}</h3>
					</div>
				</div>
				<div className="col-md-12 header-container padding-bottom-16 padding-top-8 flex flex-justify-content-space-between flex-align-items-center hidden-xs hidden-sm hidden-md">
					<div className="header-title flex flex-align-items-center flex-gap-8">
						<img
							src={icon}
							alt={title}
							height={54}
							width={54}
						/>
						<h2 className="title font-black">{lang.t(title)}</h2>
					</div>
					<div className="flex flex-justify-content-space-between flex-gap-8">
						{actions.map(action => (
							<button
								key={action.label}
								type="button"
								className="btn btn-default margin-left-8"
								onClick={action.action}
								disabled={action.disabled}
								data-test-id={action.dataTestId}
							>
								{lang.t(action.label)}
							</button>
						))}
					</div>
				</div>
			</div>
		</>
	);
};

HeaderSection.propTypes = {
	title: PropTypes.string.isRequired,
	icon: PropTypes.object,
	goBack: PropTypes.func.isRequired,
	actions: PropTypes.array.isRequired,
};

HeaderSection.defaultProps = {
	icon: {},
};

export default HeaderSection;
